import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  choiceButton: {
    color: "#FFFFFF",
    background: "#626262",
    textTransform: "none",
    width: 200,
    borderRadius: 50,
    margin: 5,
  },
  choiceButtonBlue: {
    color: "#FFFFFF",
    background: "#1D3557",
    textTransform: "none",
    width: 200,
    borderRadius: 50,
    margin: 5,
    [theme.breakpoints.down("sm")]: {
      width: 180,
    },
  },
}));

const ChoiceButton = ({ blue, label, onClick }) => {
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      size="medium"
      className={blue ? classes.choiceButtonBlue : classes.choiceButton}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

export default ChoiceButton;
